import { handleize } from '../../utils/handleize';
const vn = window.vNode;
export const createBadges = (item) => {
    const items = [];
    if (item.labels === undefined || item.labels.length < 1)
        return items;
    let index = 0;
    while (items.length < 2 && index < item.labels.length) {
        const label = item.labels[index++];
        if (label === 'hot deal')
            continue;
        items.push(vn.create('span', {
            class: `flag:label flag:${handleize(label)} fz:8 fz:10:xl-up text:uppercase text:nowrap ${items.length > 0 ? 'ml:6' : ''}`,
            'aria-hidden': true
        }, [`${label}`]));
    }
    return [
        ...items.length > 0
            ? [
                vn.create('div', { class: 'alg__result-item_flags d:flex ai:center mt:6' }, items)
            ]
            : [],
        ...item.labels.includes('hot deal')
            ? [
                vn.create('span', {
                    class: 'flag:hot-deal fz:12 pos:a z:2 l:0 t:20 fw:700 py:2 px:6 bg:accent-red color:white bdrs:tr:8 bdrs:br:8'
                }, ['HOT DEAL'])
            ]
            : []
    ];
};
